// @flow
import React, { useState, useEffect } from "react";
import { Images } from "../../Themes";
import { message, Spin, Checkbox } from "antd";
import {
  CloseOutlined,
  EditOutlined,
  LeftCircleFilled,
} from "@ant-design/icons";
import { apiRefresh } from "../../services/api";
function EzyformsClients(Props) {
  const [loading, setLoading] = useState(false);
  const [ezClients, setEzClients] = useState(false);

  useEffect(() => {
    getEzyformsSettings();
  }, []);

  const getEzyformsSettings = () => {
    const getCustomFieldOpt = {
      url: `v1/branch/EzyformShowSetting`,
    };
    getCustomFieldOpt.types = [
      "GET_EZYFORMS_SETTINGS_SUCCESS",
      "GET_EZYFORMS_SETTINGS_FAILURE",
    ];
    setLoading(true);
    apiRefresh
      .get(getCustomFieldOpt)
      .then((res) => {
        setLoading(false);
        setEzClients(res && res.isEzyformShow);
      })
      .catch((err) => {
        setLoading(false);
        setEzClients(false);
      });
  };

  const onFinish = (values) => {
    let data = {
      isEzyformShow: values,
    };
    const addCustomFieldOpt = {
      url: `v1/branch/EzyformShowSetting`,
    };
    addCustomFieldOpt.types = [
      "UPD_EZYFORMS_SETTINGS_SUCCESS",
      "UPD_EZYFORMS_SETTINGS_FAILURE",
    ];
    setLoading(true);
    apiRefresh
      .put(addCustomFieldOpt, data)
      .then((res) => {
        setLoading(false);
        message.success("Updated!");
        getEzyformsSettings();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Spin spinning={loading} size="large">
        <div
          className="d-flex align-item Reminder-top"
          style={{ justifyContent: "space-between", paddingBottom: 20 }}
        >
          <div className="d-flex align-item">
            <div className="client-tag-top">
              <img src={Images.documentSync} className="sus-bottom-icon" />
            </div>
            <span className="top-text">Ezyforms Clients</span>
          </div>

          <LeftCircleFilled
            onClick={() => Props.onSetActiveInnerTab("")}
            className="ac-back-icon"
          />
        </div>
        <div
          className="default-font-box"
          style={{ paddingLeft: 25, paddingRight: 25, paddingBottom: 25 }}
        >
          <Checkbox
            checked={ezClients}
            onChange={(e) => {
              setEzClients(e.target.checked);
              onFinish(e.target.checked);
            }}
            style={{
              padding: 10,
              marginLeft: 0,
            }}
          >
            Ezyforms Client Enabled
          </Checkbox>
        </div>
      </Spin>
    </div>
  );
}

export default EzyformsClients;
